import { Events } from "./Events";

export class EventDispatcher {

    private listeners: {type: string, listenerFunction: Function, scope: any}[];

    constructor() {

        this.listeners = [];
    }

    public hasEventListener(type: string, listenerFunction: Function): boolean {

        let exists = false;

        for (let i = 0; i < this.listeners.length; i++) {
            if (this.listeners[i].type === type && this.listeners[i].listenerFunction === listenerFunction) {
                exists = true;
            }
        }

        return exists;
    }

    public addEventListener(type: string, listenerFunction: Function, scope: any): void {

        if (this.hasEventListener(type, listenerFunction)) {
            return;
        }

        this.listeners.push({type: type, listenerFunction: listenerFunction, scope: scope});
    }

    public removeEventListener(type: string, listenerFunc: Function): void {

        for (let i = 0; i < this.listeners.length; i++) {

            if (this.listeners[i].type === type && this.listeners[i].listenerFunction === listenerFunc) {
                this.listeners.splice(i, 1);
                break;
            }
        }
    }

    public dispatchEvent(evt: Events): void {

        for (let i = 0; i < this.listeners.length; i++) {
            if (this.listeners[i].type === evt.getType()) {
                this.listeners[i].listenerFunction.apply(this.listeners[i].scope, evt.getParams());
                break;
            }
        }
    }
}
